var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyorinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    viewBox: "12 12 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 32.2 67.5 c -5.8 -11.9 -0.8 -26.4 11.1 -32.8 A 25.9 25.9 0 0 1 78 44.4 C 85.2 57 81.3 71.8 68.4 79.8 C 59 68.2 46.6 64.4 32.2 67.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 118.5 93 c 13.6 4.7 26.1 2.7 36.9 -7.3 c 10.2 4.7 14.1 20.9 7.9 32.4 a 26 26 0 0 1 -36.6 9.8 C 114.8 120.6 110.8 104.1 118.5 93 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 107.9 114.3 c 4.5 14 14 22.4 28.6 24.9 c 1.6 13 -9.5 25 -24.1 26.4 c -13.1 1.2 -26 -10.2 -27.2 -23.8 S 94.4 115.2 107.9 114.3 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 84.8 118.7 c -8.7 12.3 -9.2 25.1 -2.5 38.1 c -10.4 9 -25.4 7.6 -35.1 -2.9 a 25.8 25.8 0 0 1 1.2 -35.6 C 58.5 108.4 74.3 108.4 84.8 118.7 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 107.8 71.7 c 12.6 -8 18.1 -19.3 17.1 -33.9 c 10.2 -5 24.6 1.4 30.1 13.2 a 26 26 0 0 1 -12.6 34.6 C 129.1 91.8 113.9 85.8 107.8 71.7 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 66.6 103.4 c -14.9 0.5 -24.9 7.9 -31.2 20.8 C 23.1 123.2 14 109.4 16 95.2 c 2 -14 16.6 -23.8 30.8 -20.8 C 60.4 77.4 70 91.2 66.6 103.4 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16b3d",
    d: "M 87.8 67.6 q 5.8 -26.3 -16.8 -40.1 c 6.4 -10.1 19.9 -13.8 31.3 -8.7 A 26 26 0 0 1 116.5 49.5 C 112.9 62 101.3 69.5 87.8 67.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyorinLogo);
export default __webpack_public_path__ + "static/media/fyorin-logo.dbed9d936bfb856ce011131e296f600a.svg";
export { ForwardRef as ReactComponent };